<template>
  <el-dialog
    :title="roleId ? '编辑角色' : '添加角色'"
    :visible.sync="visible"
    width="620px"
    @closed="resetForm"
  >
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="角色名称" prop="name">
        <el-input v-model="form.name" maxlength="64" placeholder="请输入角色名称" />
      </el-form-item>
      <el-form-item label="导航权限" prop="permission_keys">
        <div class="permission-tree">
          <el-tree
            ref="permissionTree"
            :data="permissionOptions"
            show-checkbox
            node-key="key"
            default-expand-all
            :props="{ children: 'children', label: 'label' }"
            @check="syncPermissions"
          />
        </div>
        <div class="permission-tip">权限管理仅超级管理员可用，不在授权范围内。</div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { add, edit } from '@/api/roles'

const emptyForm = () => ({ name: '', permission_keys: [] })

export default {
  name: 'RoleEditDialog',
  props: {
    permissionOptions: { type: Array, default: () => [] }
  },
  data() {
    return {
      visible: false,
      saving: false,
      roleId: '',
      form: emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        permission_keys: [
          {
            type: 'array',
            required: true,
            min: 1,
            message: '请至少选择一个导航权限',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    handleCreate() {
      this.roleId = ''
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => {
        this.$refs.permissionTree.setCheckedKeys([])
        this.$refs.dataForm.clearValidate()
      })
    },
    handleEdit(role) {
      this.roleId = role.id
      this.form = { name: role.name, permission_keys: [...role.permission_keys] }
      this.visible = true
      this.$nextTick(() => {
        const parentKeys = this.permissionOptions
          .filter((item) => item.children && item.children.length)
          .map((item) => item.key)
        this.$refs.permissionTree.setCheckedKeys(
          this.form.permission_keys.filter((key) => parentKeys.indexOf(key) < 0)
        )
        this.$refs.dataForm.clearValidate()
      })
    },
    syncPermissions() {
      this.form.permission_keys = [
        ...this.$refs.permissionTree.getCheckedKeys(),
        ...this.$refs.permissionTree.getHalfCheckedKeys()
      ]
      this.$refs.dataForm.validateField('permission_keys')
    },
    resetForm() {
      this.roleId = ''
      this.form = emptyForm()
    },
    save() {
      this.syncPermissions()
      this.$refs.dataForm.validate((valid) => {
        if (!valid) return
        this.saving = true
        const request = this.roleId ? edit(this.roleId, this.form) : add(this.form)
        request
          .then(() => {
            this.$notify({
              title: '成功',
              message: this.roleId ? '角色已更新' : '角色已添加',
              type: 'success'
            })
            this.visible = false
            this.$emit('saved')
          })
          .finally(() => {
            this.saving = false
          })
      })
    }
  }
}
</script>

<style scoped>
.permission-tree {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px 12px;
}
.permission-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}
</style>
